// Example in AppRoute.js
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { FaExclamationTriangle } from 'react-icons/fa'; // Import FontAwesome icon
import App from './App';

const NotFound = () => {
  const notFoundStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: '#FFFFFF', // White background
    color: '#FFA500', // Orange color for text and icon
    fontSize: '24px',
  };

  const iconStyle = {
    fontSize: '48px',
    marginBottom: '20px',
  };

  return (
    <div style={notFoundStyle}>
      <FaExclamationTriangle style={iconStyle} />
      <h2 style={{ margin: '0' }}>404 Not Found</h2>
      <p>Sorry, the requested URL is incorrect.</p>
    </div>
  );
};

const AppRoute = () => {
  return (
    <Router>
      <Routes>
        <Route path="/pet/:petType" element={<App />} />
        <Route path="*" element={<Navigate to="/404" />} />
        <Route path="/404" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default AppRoute;
